import React, { createContext, useContext, useState } from 'react';

interface HeroAnimationContextType {
  isTransitioning: boolean;
  startTransition: (targetPath: string) => void;
  endTransition: () => void;
  targetPath: string | null;
}

const HeroAnimationContext = createContext<HeroAnimationContextType | undefined>(undefined);

export const HeroAnimationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [targetPath, setTargetPath] = useState<string | null>(null);

  const startTransition = (path: string) => {
    setTargetPath(path);
    setIsTransitioning(true);
  };

  const endTransition = () => {
    setIsTransitioning(false);
    setTargetPath(null);
  };

  return (
    <HeroAnimationContext.Provider value={{ isTransitioning, startTransition, endTransition, targetPath }}>
      {children}
    </HeroAnimationContext.Provider>
  );
};

export const useHeroAnimation = () => {
  const context = useContext(HeroAnimationContext);
  if (!context) {
    throw new Error('useHeroAnimation must be used within HeroAnimationProvider');
  }
  return context;
};